module.exports = __webpack_public_path__ + "img/companyIntro13.e931fe1c.png";